export function shortenedString(string, prefix, suffix) {
  return string.slice(0, prefix) + "..." + string.slice(-suffix)
}
export function isValidAccount(address) {
  return /^lsk[a-z0-9]{38}$/.test(address)
}
